import { faAlarmClock } from '@fortawesome/pro-regular-svg-icons/faAlarmClock';
import { faArrowAltLeft } from '@fortawesome/pro-regular-svg-icons/faArrowAltLeft';
import { faArrowAltRight } from '@fortawesome/pro-regular-svg-icons/faArrowAltRight';
import { faAsterisk } from '@fortawesome/pro-regular-svg-icons/faAsterisk';
import { faBoxAlt } from '@fortawesome/pro-regular-svg-icons/faBoxAlt';
import { faCalendarDay } from '@fortawesome/pro-regular-svg-icons/faCalendarDay';
import { faChevronSquareUp } from '@fortawesome/pro-regular-svg-icons/faChevronSquareUp';
import { faClock } from '@fortawesome/pro-regular-svg-icons/faClock';
import { faExternalLink } from '@fortawesome/pro-regular-svg-icons/faExternalLink';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons/faInfoCircle';
import { faMailbox } from '@fortawesome/pro-regular-svg-icons/faMailbox';
import { faPencil } from '@fortawesome/pro-regular-svg-icons/faPencil';
import { faPersonCarry } from '@fortawesome/pro-regular-svg-icons/faPersonCarry';
import { faPersonDolly } from '@fortawesome/pro-regular-svg-icons/faPersonDolly';
import { faTimesHexagon } from '@fortawesome/pro-regular-svg-icons/faTimesHexagon';
import { faTrashAlt } from '@fortawesome/pro-regular-svg-icons/faTrashAlt';
import { faTreeAlt } from '@fortawesome/pro-regular-svg-icons/faTreeAlt';
import { faTruck } from '@fortawesome/pro-regular-svg-icons/faTruck';
import { faUserClock } from '@fortawesome/pro-regular-svg-icons/faUserClock';
import { faUserHardHat } from '@fortawesome/pro-regular-svg-icons/faUserHardHat';
import { faProjectDiagram } from '@fortawesome/pro-regular-svg-icons/faProjectDiagram';
export var FaLibrary = [
    faArrowAltLeft,
    faArrowAltRight,
    faAsterisk,
    faBoxAlt,
    faTimesHexagon,
    faPersonDolly,
    faCalendarDay,
    faPersonCarry,
    faPencil,
    faClock,
    faUserClock,
    faTrashAlt,
    faTreeAlt,
    faAlarmClock,
    faMailbox,
    faInfoCircle,
    faTruck,
    faChevronSquareUp,
    faExternalLink,
    faUserHardHat,
    faProjectDiagram
];
//# sourceMappingURL=FaLibrary.js.map